import storageActions from "app/utils/storageActions";

export const initialState = {
  loading: true,
  todoIds: [],
  dismissedTodos: [],
  hiddenIds: [],
  focusIds: [],
  schemeMode: "auto",
  lightTheme: "",
  darkTheme: "",
  globalDetailsMode: "",
};

export const preferences = (state = initialState, action) => {
  const { type, ...data } = action;
  switch (type) {
    case "preferences/update": {
      const preferences = {
        ...state,
        ...action.preferences,
      };
      storageActions.saveItem("preferences", preferences);
      return {
        ...preferences,
      };
    }
    case "preference/update": {
      const preferences = {
        ...state,
        ...data,
      };
      storageActions.saveItem("preferences", preferences);
      return preferences;
    }
    // case 'preference/add_focus': {
    //   // const index = state[action.key].indexOf(action.id)
    //   const preferences = {
    //     ...state,
    //     focusIds: [
    //       ...state.focusIds,
    //       action.id
    //     ]
    //   }
    //   storageActions.saveItem('preferences', preferences)
    //   return preferences
    // }
    default:
      return state;
  }
};
